@if (showPage) {
  <div>
    <!-- for web button -->
    <!---this container let you add extra functionality via decorator-->
    <ng-container #appendHtml></ng-container>
    @if (!utilService.isMobile() && !showflatform && current_action!='VIEW' && !hide_array_button && !this.question.hideAdd && !this.question.view_mode) {
      <button type="button" (click)="addRow()" [ngClass]="buttonProps.buttonClass" [disabled]="btnDisabled"
        >{{buttonText}}
        @if (buttonProps && buttonProps.buttonIcon) {
          <i [ngClass]="buttonProps.buttonIcon"></i>
        }</button>
      }
      <!-- for mobile button -->
      @if (utilService.isMobile() && !showflatform && current_action!='VIEW' && !hide_array_button && !this.question.hideAdd && !this.question.view_mode) {
        <button type="button" (click)="addRow()" class="mobile-primary-btn" [disabled]="btnDisabled"
          ><i
        class="fa fa-plus"></i>
        @if(buttonText){
          {{buttonText}}
        }@else {
          {{ 'button.add' | translate | async }}
        }
      </button>
    }
    @if (showflatform && current_action!='VIEW' && !this.question.view_mode && !this.question.hideform) {
      <!-- <div class="col-12 col-md-12 col-lg-12"> -->
      @if (showflatform) {
        <dhs-form [bookmarks]="this.formBlocks.bookmark!=undefined?this.formBlocks:''" [config]="form_config"
          [fieldGroup]="popupfields" (saveFinished)="addRows($event)" (getData)="getDataFn($event)"
          [action]="current_action" [customButton]='btn' [formtype]="'popup'" [decorator]="decorator" [data]="objData"
          >
        </dhs-form>
      }
      <div class="col-md-3 col-lg-3 col-xl-3"></div>
    <!-- </div> -->
  }
  <!-- <div class="table-responsive"
  *ngIf="items != null && !(this.formBlocks.blocks && this.formBlocks.blocks[0].hide_empty_table && items.length==0) && !utilService.isMobile()">
  <table class="base-table" [ngClass]="current_action !='VIEW' ? 'table-actions': ''">
    <thead>
      <tr>
        <ng-container *ngFor="let field of fields">
          <th scope="col" *ngIf="!field.hidden">
            <span>{{ field.heading | translate | async}}</span>
          </th>
        </ng-container>
        <th *ngIf="current_action!='VIEW'"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of items; let i = index">
        <ng-container *ngFor="let field of fields">
          <td scope="row" *ngIf="!field.hidden">
            <span>
            </span>
            <span *ngIf="field.type=='popover' || field.type==undefined || !field.type"
              [innerHTML]='getValue(item, field)'
              [popover]="field.type == 'popover' ? getValue(item, field) : undefined"
              triggers="mouseenter:mouseleave" placement="top left" container="body">
            </span>
            <span *ngIf="field.type === 'boolean'">
              {{ getValue(item, field) }}
            </span>
            <span *ngIf="field.type === 'composite'">
              {{ getValue(item, field) }}
            </span>
            <span *ngIf="field.type === 'array'">
              {{ getValue(item, field) }}
            </span>
            <span *ngIf="field.type === 'compositeDate'">
              {{ getValue(item, field) ? (getValue(item, field) | dateFormat) : ''}}
            </span>
            <span *ngIf="field.type === 'compositeDatetime'">
              {{ getValue(item, field) ? (getValue(item, field) | dateTimeFormat) : ''}}
            </span>
            <span *ngIf="field.type === 'compositeTime'">
              {{ getValue(item, field) ? (getValue(item, field) | timeFormat) : ''}}
            </span>
            <span *ngIf="field.type === 'date'">
              {{ getValue(item, field) ? (getValue(item, field) | dateFormat) : ''}}
            </span>
            <span *ngIf="field.type === 'datetime'">
              {{ getValue(item, field) ? (getValue(item, field) | dateTimeFormat) : ''}}
            </span>
            <span *ngIf="field.type === 'time'">
              {{ getValue(item, field) ? (getValue(item, field) | timeFormat) : ''}}
            </span>
            <span *ngIf="field.type === 'image' && field.config != undefined">
              <app-image-thumb [imagedata]="{config:field.config,data:item}"> </app-image-thumb>
            </span>
            <span *ngIf="field.type === 'monthYear'">
              {{ getValue(item, field) ? (getValue(item, field) | MonthYearFormat) : ''}}
            </span>
            <span *ngIf="field.type === 'document'">
              <a href="javascript:void(0)" (click)="showDocument(item, field);">{{val | documentName:
              item:field | async}}</a>
            </span>
            <span *ngIf="field.type === 'map'">
              {{ item | mapvalue: field }}
            </span>
            <span *ngIf="field.type === 'link'">
              <a style="color:blue; cursor:pointer" (click)="openPopUp(field,item)">{{ field.heading |
              translate | async}}</a>
            </span>
            <span *ngIf="field.type === 'composite-array'" class="row">
              <dhs-composite-array [items]="getValue(item, field)" [id]="field.name"
                [resource]="field.resource" [current_action]="'VIEW'">
              </dhs-composite-array>
            </span>
          </td>
        </ng-container>
        <td class="tdmiddle" *ngIf="current_action!='VIEW'">
          <span class="ca-actions pr-2" (click)="editRow(i)" *ngIf="!this.question.hideEdit">
            <span class="fa fa-pencil"></span>
          </span>
          <span class="ca-actions pl-2" (click)="removeRow(i)" *ngIf="!this.question.hideDelete">
            <span class="fa fa-trash"></span>
          </span>
          <ng-container *ngIf="customCapability.length > 0">
            <ng-container *ngFor="let capability of customCapability">
              <span class="ca-actions pl-2" (click)="clickCapability(capability, item,i)"
                *ngIf="capability.expression ? checkExpression(capability, item): true">
                <span [ngClass]="capability.icon"></span>
              </span>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div> -->
<!---------Don't delete this code ------@Sanjeev-->
<!-- <span class="ca-actions pl-2" (click)="getMonoGraph(i)" *ngIf="isCims.is_cims">
<span class="fa fa-info"></span>
</span> at line 110 -->
<!-- <tbody *ngIf="items.length == 0">
<span style="font-weight: bold;text-align: center;">No records found</span>
</tbody> at line123-->
<!----For view case only---->
@if (current_action && (current_action == 'VIEW' || this.question.view_mode)) {
  @if ((items != null && fields && !(formBlocks.blocks && isItemSizeZero)) || this.storeItems) {
    <dhs-data-grid  [fields]="fields" [config]="gridConfig" #datagrid
      [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="{resource:items, count:counts}"
    (editEllipseClick)="itemClick($event)" (bindGrid)="filterData($event)" (onLimitChange)="onLimitChange($event)" (onPageChanges)="onPageChange($event)" (onFilterChange)="filterChange($event)"></dhs-data-grid>
  }
}
<!------End-->
<!-- data =     {{items | json}} -->
@if (!this.question.view_mode && current_action!='VIEW' && (items != null && fields?.length > 0 && !(formBlocks.blocks && isItemSizeZero)) || this.storeItems) {
  <dhs-data-grid  [fields]="fields" [config]="gridConfig" #datagrid
    [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="{resource:items, count:counts}"
  [bulkActionsConfig]="_currentData.currentCompositeArrayBulkAction" (configValues)="getConfigValues($event)" (bulkActionClicked)="onBulkActionClicked($event)" (editEllipseClick)="itemClick($event)" (bindGrid)="filterData($event)" (onLimitChange)="onLimitChange($event)" (onPageChanges)="onPageChange($event)" (onFilterChange)="filterChange($event)"></dhs-data-grid>
}
@if ((!this.question.view_mode && current_action!='VIEW' && (items != null && fields && !(formBlocks.blocks && items.length==0)) || this.storeItems) && gridConfig && gridConfig.compositeGridOutsideText && gridConfig.compositeGridOutsideText?.id && gridConfig.compositeGridOutsideText?.text && (items[0]?.[gridConfig.compositeGridOutsideText.id] != undefined && items[0]?.[gridConfig.compositeGridOutsideText.id] != '' && items[0]?.[gridConfig.compositeGridOutsideText.id] != 0)) {
  <div [ngClass]="(gridConfig?.compositeGridOutsideText?.class)?gridConfig.compositeGridOutsideText.class:''">
    {{gridConfig.compositeGridOutsideText.text}}{{items[0]?.[gridConfig.compositeGridOutsideText.id]}}
  </div>
}
</div>
}
<!-- <div dhs-modal></div> -->